import httpFactory, { HttpType } from "@/api/httpFactory";
export default {
    async getAll() {
        const http = httpFactory.getHttp(HttpType.Api);
        const response = await http.get("service-categories");
        return response.data;
    },
    async get(id) {
        const http = httpFactory.getHttp(HttpType.Api);
        const response = await http.get(`service-categories/${id}`);
        return response.data;
    },
    async create(request) {
        const http = httpFactory.getHttp(HttpType.Api);
        const response = await http.post("service-categories", request);
        return response.data;
    },
    async edit(id, request) {
        const http = httpFactory.getHttp(HttpType.Api);
        const response = await http.post(`service-categories/${id}`, request);
        return response.data;
    }
};
